import React from 'react';
import styled from 'styled-components';
import { FaWhatsapp } from 'react-icons/fa';
import { theme } from '../styles/theme';

const FloatingButton = styled.a`
  position: fixed;
  width: 60px;
  height: 60px;
  bottom: 40px;
  right: 40px;
  background-color: #25D366; /* Keeping WhatsApp's brand color */
  color: #FFF;
  border-radius: 50px;
  text-align: center;
  font-size: 30px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);
  border: 2px solid ${theme.colors.secondary};
  z-index: 100;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
  
  &:hover {
    background-color: #128C7E; /* WhatsApp's darker green */
    transform: scale(1.1);
    color: #FFF;
    border: 2px solid ${theme.colors.tertiary};
    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.4);
  }
  
  @media screen and (max-width: 768px) {
    width: 50px;
    height: 50px;
    bottom: 20px;
    right: 20px;
    font-size: 25px;
  }
`;

const WhatsAppButton = () => {
  const phoneNumber = '27740217708'; // Your WhatsApp number in international format (no + sign)
  const message = 'Hello! I visited your website and would like to know more about your services.';
  const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
  
  return (
    <FloatingButton href={whatsappUrl} target="_blank" aria-label="Chat on WhatsApp">
      <FaWhatsapp />
    </FloatingButton>
  );
};

export default WhatsAppButton;
